"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _mobx = require("mobx");
var _mobxReact = require("mobx-react");
var _react = _interopRequireWildcard(require("react"));
var _forEachRight = _interopRequireDefault(require("lodash/forEachRight"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _imageUtils = require("../../utils/image-utils");
var _overlayShapesUtils = require("../../utils/overlay-shapes-utils");
var _styles = require("./styles");
var _constants = require("./constants");
var _dec, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _OverlayComponent; //helpers
//styles
//constants
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer && (Object.defineProperty(i, e, a), a = null), a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var OverlayComponent = (_dec = _mobx.observable.ref, (0, _mobxReact.observer)(_class = (_class2 = (_OverlayComponent = /*#__PURE__*/function (_Component) {
  function OverlayComponent(props) {
    var _this;
    _classCallCheck(this, OverlayComponent);
    _this = _callSuper(this, OverlayComponent, [props]);
    _initializerDefineProperty(_this, "width", _descriptor, _this);
    _initializerDefineProperty(_this, "height", _descriptor2, _this);
    _initializerDefineProperty(_this, "x", _descriptor3, _this);
    _initializerDefineProperty(_this, "y", _descriptor4, _this);
    _initializerDefineProperty(_this, "overlayShapes", _descriptor5, _this);
    _defineProperty(_this, "konvaStage", null);
    _defineProperty(_this, "konvaLayer", null);
    _defineProperty(_this, "konvaContainerRef", null);
    _defineProperty(_this, "disposeUpdater", _noop["default"]);
    _initializerDefineProperty(_this, "handleResize", _descriptor6, _this);
    _defineProperty(_this, "setKonvaContainerRef", function (konvaContainerRef) {
      _this.konvaContainerRef = konvaContainerRef;
    });
    _initializerDefineProperty(_this, "setOverlayShapes", _descriptor7, _this);
    _defineProperty(_this, "updateKonva", function () {
      var _this2 = _this,
        height = _this2.height,
        overlayShapes = _this2.overlayShapes,
        width = _this2.width;
      if (!_this.konvaContainerRef) {
        return;
      }
      if (_this.konvaStage) {
        _this.konvaStage.size({
          width: width,
          height: height
        });
      } else {
        _this.konvaStage = (0, _overlayShapesUtils.initializeKonvaStage)(_this.konvaContainerRef, width, height);
      }
      if (_this.konvaLayer) {
        _this.konvaLayer.destroy();
      }
      if ((0, _isEmpty["default"])(overlayShapes)) {
        return;
      }
      _this.konvaLayer = (0, _overlayShapesUtils.initializeKonvaLayer)();
      _this.konvaStage.add(_this.konvaLayer);
      (0, _forEachRight["default"])(overlayShapes, function (shape) {
        var konvaShape = (0, _overlayShapesUtils.drawShape)(shape, width, height);
        _this.konvaLayer.add(konvaShape);
        _this.konvaLayer.draw();
      });
    });
    (0, _mobx.makeObservable)(_this);
    return _this;
  }
  _inherits(OverlayComponent, _Component);
  return _createClass(OverlayComponent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.disposeUpdater = (0, _mobx.autorun)(this.updateKonva);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var overlayShapes = this.props.overlayShapes;
      if (overlayShapes !== prevProps.overlayShapes) {
        this.setOverlayShapes(overlayShapes);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.konvaStage) {
        this.konvaStage.destroy();
      }
      this.disposeUpdater();
    }
  }, {
    key: "render",
    value: function render() {
      var shouldShowOverlayShapes = this.props.shouldShowOverlayShapes;
      return /*#__PURE__*/_react["default"].createElement(_styles.Overlay, {
        onResize: this.handleResize
      }, shouldShowOverlayShapes && /*#__PURE__*/_react["default"].createElement(_styles.KonvaContainer, {
        ref: this.setKonvaContainerRef,
        style: {
          left: this.x,
          top: this.y
        }
      }));
    }
  }]);
}(_react.Component), _defineProperty(_OverlayComponent, "propTypes", {
  imageAspectRatio: _propTypes["default"].number.isRequired,
  imageFit: _propTypes["default"].oneOf(['contain', 'cover']).isRequired,
  imageObjectPositionX: _propTypes["default"].number.isRequired,
  imageObjectPositionY: _propTypes["default"].number.isRequired
}), _OverlayComponent), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "width", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "height", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "x", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "y", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "overlayShapes", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return this.props.overlayShapes;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "handleResize", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;
    return function () {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        containerWidth = _ref.width,
        containerHeight = _ref.height;
      var _this3$props = _this3.props,
        imageAspectRatio = _this3$props.imageAspectRatio,
        imageFit = _this3$props.imageFit,
        imageObjectPositionX = _this3$props.imageObjectPositionX,
        imageObjectPositionY = _this3$props.imageObjectPositionY,
        imageMetadata = _this3$props.imageMetadata;

      // Fit image into container:
      var imageRect = (0, _imageUtils.getFittingRect)(imageFit, imageObjectPositionX, imageObjectPositionY, containerWidth, containerHeight, imageAspectRatio);
      var _convertFocusPointToC = (0, _imageUtils.convertFocusPointToCss)(_constants.ASPECT_RATIO, imageAspectRatio, imageMetadata),
        overlayObjectPositionX = _convertFocusPointToC.kx,
        overlayObjectPositionY = _convertFocusPointToC.ky;

      // Fit overlay into image:
      var overlayRect = (0, _imageUtils.getFittingRect)(imageFit === 'cover' ? 'contain' : 'cover', overlayObjectPositionX, overlayObjectPositionY, imageRect.width, imageRect.height, _constants.ASPECT_RATIO);
      _this3.width = overlayRect.width;
      _this3.height = overlayRect.height;
      _this3.x = imageRect.x + overlayRect.x;
      _this3.y = imageRect.y + overlayRect.y;
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "setOverlayShapes", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;
    return function (overlayShapes) {
      _this4.overlayShapes = overlayShapes;
    };
  }
})), _class2)) || _class);
var _default = exports["default"] = OverlayComponent;
//# sourceMappingURL=index.js.map